'use strict';

var _webviewComms = require('./webview-comms');

var _webviewComms2 = _interopRequireDefault(_webviewComms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.__webview_comms__ = new _webviewComms2.default();

// Check if we are in an iframe
if (window.top !== window.self) {
  window.__webview_comms__.setPostMessage(function (data) {
    return window.parent.postMessage(data, '*');
  });

  window.addEventListener('message', function () {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _message$data = message.data,
        id = _message$data.id,
        event = _message$data.event,
        _message$data$data = _message$data.data,
        data = _message$data$data === undefined ? {} : _message$data$data;

    if (typeof id !== 'undefined') {
      window.__webview_comms__.reply({ id: id, data: data });
    } else if (typeof event !== 'undefined') {
      window.__webview_comms__.notify({ event: event, data: data });
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@fitbit/webview-comms-lib/lib/add-comms.js
// module id = 227
// module chunks = 0